import { render } from "./OverviewMissingSideNav.vue?vue&type=template&id=1194e15c"
import script from "./OverviewMissingSideNav.vue?vue&type=script&lang=js"
export * from "./OverviewMissingSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__